<template>
  <v-app>
    <!--Logout where it gives a message on the screen, for a while. as one are logging out-->
    <v-content>
      <v-row>
        <v-col shrink class="text-center pt-12">
          <p class="title">Logging out.</p>
        </v-col>
      </v-row>
    </v-content>
  </v-app>
</template>
<script>
export default {
  methods: {
    // Sends an dispatch action to mutate the state to logout, then set an 1000 timeout, displaying the html above
    logout: function () {
      this.$store.dispatch('logout')
      .then(() => {
        setTimeout(() => {this.$router.push({name: "frontpage"})}, 1000)
      })
    }
  },
  mounted() {
    this.logout();
  }
}
</script>
